import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Error, Success } from "../../../commons/Messages/Messages";
import { setAuthentication } from "../../../commons/Auth/auth";
import NormalUserLayout from "../../../layouts/NormalUserLayout/NormalUserLayout";
import { useState } from "react";
import { Button, Form, Input } from "antd";
import { WhiteLSLogo, LeistFusionLogo } from "../../../commons/PanelImagepath";
import "./AuthPage.css";
import { useTranslation } from "react-i18next";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import {
  isNative,
  getTenantDomain,
  setTenantDomain,
  normalizeTenantDomain
} from "../../../native/platform";

const LoginContainer = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const onSubmit = async data => {
    setLoading(true);
    const { companyDomain, ...body } = data;
    body.role = 0;
    // The native app has no tenant origin; name the tenant explicitly (see native/platform.js).
    const params = {};
    if (isNative) {
      params.domain = normalizeTenantDomain(companyDomain);
      setTenantDomain(params.domain);
    }
    await axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/users/login`, body, { params })
      .then(res => {
        setLoading(false);

        if (res.status === 200 || res.status === 304) {
          setAuthentication(res.data.user, res.data.token);
          Success(res.data.successMessage);
          i18n.changeLanguage(res.data?.user?.language || "en");
          setTimeout(() => {
            const role = res?.data?.user?.role;
            const historySring =
              role === 2
                ? "/user"
                : role === 1
                  ? "/user"
                  : role === 3
                    ? "/subadmin"
                    : role === 4
                      ? "/admin"
                      : role === 0
                        ? "/client"
                        : "/user";
            history.push(historySring);
          }, 500);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        generalErrorAlert(err.message);
      });
  };

  useEffect(() => {
    document.body.classList.add("account-page");

    return () => document.body.classList.remove("account-page");
  }, []);

  return (
    <NormalUserLayout>
      <main className="auth-page">
        <div className="auth-page__card auth-page__card--split">
          <div className="auth-page__brand auth-page__brand--hero">
            <img src={WhiteLSLogo} alt="LeistFusion" />
            <p className="auth-page__tagline">
              {t("Projects, team, appointments and accounting in one place.")}
            </p>
          </div>
          <div className="auth-page__body">
            <img className="auth-page__mobile-logo" src={LeistFusionLogo} alt="" />
            <h1 className="auth-page__title">{t("Welcome back")}</h1>
            <p className="auth-page__subtitle">{t("Sign in to your account to continue.")}</p>
            <Form
              className="auth-page__form"
              name="basic"
              layout="vertical"
              size="large"
              onFinish={onSubmit}
              requiredMark={false}
              initialValues={{ companyDomain: getTenantDomain().replace(/^https:\/\//, "") }}
            >
              {isNative && (
                <Form.Item
                  label={t("Company web address")}
                  name="companyDomain"
                  extra={t("The address you use in the browser, e.g. firma.de")}
                  rules={[
                    {
                      required: true,
                      message: t("forms.requiredText", { field: t("Company web address") })
                    }
                  ]}
                >
                  <Input
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}
                    inputMode="url"
                    placeholder="firma.de"
                  />
                </Form.Item>
              )}
              <Form.Item
                label={`${t("forms.email")}/${t("forms.username")}`}
                name="email"
                rules={[
                  {
                    required: true,
                    message: t("forms.requiredText", { field: t("email") })
                  }
                ]}
              >
                <Input
                  autoComplete="username"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                  inputMode="email"
                />
              </Form.Item>
              <Form.Item
                label={t("forms.password")}
                name="password"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: t("forms.requiredText", { field: t("password") })
                  }
                ]}
              >
                <Input.Password autoComplete="current-password" />
              </Form.Item>
              <Form.Item className="auth-page__submit">
                <Button type="primary" htmlType="submit" block loading={loading}>
                  {t("login")}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </main>
    </NormalUserLayout>
  );
};

export default LoginContainer;
